import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Mail } from "lucide-react";
import { fmtEUR } from "../../../lib/api";
import { Panel, GhostBtn } from "./ui";

export function Opportunities({ items }) {
  const nav = useNavigate();
  const act = (o) => o.kind === "email" ? ["Rispondi", "/email-ai"] : o.status === "Bozza" ? ["Invia preventivo", "/preventivi"] : ["Vedi dettagli", "/preventivi"];
  return (
    <Panel title="Opportunità commerciali" badge="AI" testid="nx-opps" bodyClass="px-3 pb-3">
      <div id="nx-opps" className="space-y-1.5 max-h-[300px] overflow-y-auto scroll-mt-24">
        {items.map(o => {
          const [label, to] = act(o);
          const Icon = o.kind === "email" ? Mail : FileText;
          return (
            <div key={`${o.kind}-${o.id}`} className="flex items-center gap-3 p-2.5 rounded-xl border border-white/6 bg-white/[0.02]" data-testid={`nx-opp-${o.id}`}>
              <Icon size={18} className={o.kind === "email" ? "text-sky-300 shrink-0" : "text-[#E9C46A] shrink-0"} />
              <div className="min-w-0 flex-1"><div className="text-[13px] text-white truncate">{o.title}</div><div className="text-[11px] text-slate-400 truncate">{o.sub}</div></div>
              {o.amount != null && <div className="text-right shrink-0"><div className="text-[9.5px] text-slate-500">Importo</div><div className="text-[13px] text-emerald-300 font-mono-num">{fmtEUR(o.amount)}</div></div>}
              <GhostBtn onClick={() => nav(to)} testid={`nx-opp-act-${o.id}`} className={label === "Invia preventivo" ? "border-[#D4A72C]/50 text-[#F1D27A]" : ""}>{label}</GhostBtn>
            </div>
          );
        })}
        {!items.length && <div className="text-sm text-slate-500 text-center py-10" data-testid="nx-opps-empty">Nessun preventivo aperto o richiesta email da gestire</div>}
      </div>
    </Panel>
  );
}
